var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPending = function SvgPending(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_872_194980)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99909 1.9334C4.64856 1.9334 1.93242 4.64954 1.93242 8.00007C1.93242 11.3506 4.64856 14.0667 7.99909 14.0667C11.3496 14.0667 14.0658 11.3506 14.0658 8.00007C14.0658 4.64954 11.3496 1.9334 7.99909 1.9334ZM0.732422 8.00007C0.732422 3.9868 3.98582 0.733398 7.99909 0.733398C12.0124 0.733398 15.2658 3.9868 15.2658 8.00007C15.2658 12.0133 12.0124 15.2667 7.99909 15.2667C3.98582 15.2667 0.732422 12.0133 0.732422 8.00007ZM7.99909 4.06673C8.33046 4.06673 8.59909 4.33536 8.59909 4.66673V7.56761L10.1888 8.09752C10.5032 8.20231 10.6731 8.5421 10.5683 8.85647C10.4635 9.17084 10.1237 9.34073 9.80935 9.23594L7.80935 8.56928C7.56435 8.48761 7.39909 8.25832 7.39909 8.00007V4.66673C7.39909 4.33536 7.66772 4.06673 7.99909 4.06673Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_872_194980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pending.e7d41c6076a79483dffbceff32960ca8.svg";